<template>
  <div>
    <div v-for="([colData, label], idx) in getList" :key="colData" class="d-grid mt-1">
      <el-switch
        :class="fieldType"
        active-color="#270E66"
        :active-text="$i18n.t(label)"
        :value="isChecked(colData)"
        @change="onChange(colData)"
        :id="`${fieldNameProp}-${idx}-choicelist`"
      >
      </el-switch>
      <slot name="aggregation" :col-data="colData" />
    </div>
  </div>
</template>
<script>
import { compact, get } from 'lodash'

export default {
  /**
   * @param ChoiceList component
   *
   * @description A listák mezőinek szelektálására szolgálló componens
   */
  name: 'ChoiceList',
  inheritAttrs: false,
  props: {
    id: {
      type: String,
    },
    name: {
      type: String,
    },
    type: {
      type: String,
    },
    list: {
      type: [Array, Object],
      default: () => [],
    },
    aggregations: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [Array, Number, String],
    },
    fieldNameProp: {
      type: String
    }
  },
  methods: {
    onChange(index) {
      this.$emit('change', index)
    },
    isChecked(id) {
      const value = Array.isArray(this.value) ? this.value.map((val) => String(val)) : String(this.value)
      if (this.type === 'checkboxlist') {
        return value.includes(String(id))
      }
      return String(this.value) === String(id)
    },
    normalizeValue(value) {
      return get(value, '0.name', null) ? [value[0].name, value[1].name] : value
    },
  },
  computed: {
    fieldType() {
      return this.type === 'checkboxlist' ? 'checkbox' : 'radio'
    },
    getList() {
      if (Array.isArray(this.list)) {
        return compact(this.list.map((e) => this.normalizeValue(e)))
      } else {
        return Object.entries(this.list).map((e) => this.normalizeValue(e))
      }
    },
    fieldName() {
      return this.type === 'checkboxlist' ? `${this.name}[]` : this.name
    },
  },
}
</script>

<style lang="scss" scoped>
.d-grid {
  grid-template-columns: 1fr auto auto;
  align-items: center;
}
</style>
